/* The Katha: Curtains page. Width × height → from-price, and the WhatsApp links. No network, no storage. */
(function () {
  var root = document.querySelector('[data-kc]');
  if (!root) return;
  var wa = root.getAttribute('data-wa') || '';
  var RATE = +root.getAttribute('data-rate') || 700000;
  var MAX_H = +root.getAttribute('data-max-h') || 260;
  var $ = function (sel) { return root.querySelector(sel); };
  var rp = function (n) { n = Math.round(n / 1000) * 1000; return 'Rp ' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var waLink = function (msg) { return 'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg); };

  /* made to measure */
  var inW = $('[data-kc-w]'), inH = $('[data-kc-h]'), price = $('[data-kc-price]'), how = $('[data-kc-how]'), btn = $('[data-kc-wa-measure]');
  var flow = 2.5, rail = 'have', floor = 'kiss', fab = 'linen', col = 'flax', head = 'tab top', parts = 'two parts';
  var FAB = { linen: 'sheer linen', vitrase: 'vitrase', blackout: 'blackout' };
  var FLOOR = { above: 'just above the floor', kiss: 'kissing the floor', pool: 'pooling on the floor' };
  function calc() {
    if (!inW || !inH || !price) return;
    var w = Math.max(50, +inW.value || 0), h = Math.max(0, +inH.value || 0);
    var m = Math.ceil(w * flow / 10) / 10;
    var msg, extra = ' · ' + head + ', ' + parts + ', ' + FLOOR[floor] + (rail === 'need' ? ' · railing quoted with the project' : '');
    if (fab !== 'linen') {
      price.textContent = 'we confirm in your quote';
      how.textContent = FAB[fab] + ' curtain' + (col ? ' in ' + col : '') + ', about ' + m + ' m for a ' + w + ' cm rail at flow ' + flow + extra + ' · priced per metre of finished curtain; send the sizes and we quote it the same day.';
      msg = 'hi the katha, a ' + FAB[fab] + ' curtain quote please' + (col ? ' in ' + col : '') + ': rail ' + w + ' cm, height ' + h + ' cm, flow ' + flow + ', ' + head + ', ' + parts + ', ' + FLOOR[floor] + (rail === 'need' ? ', with railing' : '') + '.';
      if (btn) btn.href = waLink(msg);
      return;
    }
    if (h > MAX_H) {
      price.textContent = 'ask us';
      how.textContent = 'above ' + MAX_H + ' cm the curtain is joined, so it is a different calculation. send the sizes and we quote them.';
      msg = 'hi the katha, a curtain quote please: rail ' + w + ' cm, height ' + h + ' cm, flow ' + flow + ', sheer linen in ' + col + ', ' + head + ', ' + parts + ', ' + FLOOR[floor] + (rail === 'need' ? ', with railing' : '') + '. it is taller than ' + MAX_H + ' cm.';
    } else {
      price.textContent = 'from ' + rp(m * RATE);
      how.textContent = m + ' m of sheer linen in ' + col + ' × ' + rp(RATE) + ' per metre of finished curtain · one metre is about 100 cm wide and up to 260 cm high · flow ' + flow + extra + (head === 'pinch pleat' ? ' · pinch pleat is a custom heading, quoted' : '') + ' · sewing, standard header, service and one revision included';
      msg = 'hi the katha, a curtain please: rail ' + w + ' cm, height ' + h + ' cm, flow ' + flow + ', ' + head + ', ' + parts + ', ' + FLOOR[floor] + (rail === 'need' ? ', with railing' : '') + '. sheer linen curtain in ' + col + ', about ' + m + ' m, from ' + rp(m * RATE) + '.';
    }
    if (btn) btn.href = waLink(msg);
  }
  root.querySelectorAll('[data-kc-flow]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-kc-flow]').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on'); flow = +b.getAttribute('data-kc-flow') || 2.5; calc();
    });
  });
  var colNote = $('[data-kc-colnote]'), colName = $('[data-kc-colname]'), headName = $('[data-kc-headname]');
  [['data-kc-rail', function (v) { rail = v; }], ['data-kc-floor', function (v) { floor = v; }], ['data-kc-parts', function (v) { parts = v; }],
   ['data-kc-col', function (v) { col = v; if (colName) colName.textContent = v; }],
   ['data-kc-head', function (v) { head = v; if (headName) headName.textContent = v; }],
   ['data-kc-fab', function (v) {
     fab = v; var any = false, firstDot = null;
     root.querySelectorAll('[data-kc-col]').forEach(function (d) { var ok = (d.getAttribute('data-kc-for') || 'linen') === v; d.hidden = !ok; d.classList.remove('is-on'); if (ok) { any = true; if (!firstDot) firstDot = d; } });
     if (firstDot) { firstDot.classList.add('is-on'); col = firstDot.getAttribute('data-kc-col'); if (colName) colName.textContent = col; } else { col = ''; if (colName) colName.textContent = 'to confirm'; }
     if (colNote) colNote.hidden = any;
   }]].forEach(function (pair) {
    root.querySelectorAll('[' + pair[0] + ']').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[' + pair[0] + ']').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on'); pair[1](b.getAttribute(pair[0])); calc();
      });
    });
  });
  if (inW) inW.addEventListener('input', calc);
  if (inH) inH.addEventListener('input', calc);
  calc();

  /* projects form → WhatsApp */
  var form = $('[data-kc-form]'), pbtn = $('[data-kc-wa-project]');
  if (form && pbtn) {
    var pick = function (sel) { return [].map.call(form.querySelectorAll(sel + ' .is-on'), function (x) { return x.textContent.trim(); }); };
    var build = function () {
      var type = pick('[data-kc-type]')[0] || 'villa', need = pick('[data-kc-need]').join(', ');
      var loc = (form.querySelector('[data-kc-loc]') || {}).value || '', win = (form.querySelector('[data-kc-win]') || {}).value || '';
      var sizes = (form.querySelector('[data-kc-sizes]') || {}).value || '', note = (form.querySelector('[data-kc-note]') || {}).value || '';
      var msg = 'hi the katha, curtains for a ' + type + (loc ? ' in ' + loc : '') + (win ? ', ' + win + ' windows' : '') + (sizes ? '. sizes: ' + sizes : '') + (need ? '. we need: ' + need : '') + (note ? '. ' + note : '') + '. could you send a plan and a price?';
      pbtn.href = waLink(msg);
    };
    form.querySelectorAll('[data-kc-type], [data-kc-need]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (g.hasAttribute('data-multi')) b.classList.toggle('is-on');
        else { g.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on'); }
        build();
      });
    });
    form.querySelectorAll('input, textarea').forEach(function (i) { i.addEventListener('input', build); });
    build();
  }
})();
